var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useRegoLookup } from '../../hooks/vehicle/useRegoLookup';
import { useForm } from '../../context/FormContext';
import { createSetRegoDetailsAction, createSetVehicleDetailsAction, createSetStepAction } from '../../types/form/actions';
import { ApiClient } from '../../api/apiClient';
import { testVehicles } from '../../utils/testData';
import { getTranslation } from '../../utils/i18n';
import Dialog from '../common/Dialog';
import { SafeHtmlMessage } from '../SafeHtmlMessage';
import { trackFindYourCar } from '../../utils/analytics';
// Use environment variable from window.tiofSettings
var USE_TEST_VEHICLES = ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.useTestVehicles) || false;
export var RegoLookup = function (_a) {
    var _b;
    var onVehiclesFound = _a.onVehiclesFound, savedData = _a.savedData, onShowManualLookup = _a.onShowManualLookup;
    // Get form context
    var _c = useForm(), formState = _c.state, dispatch = _c.dispatch;
    // Get saved data safely with optional chaining
    var savedFormData = ((_b = window === null || window === void 0 ? void 0 : window.tiofSettings) === null || _b === void 0 ? void 0 : _b.savedData) || {};
    // Simplify initial value selection with a helper function
    var getInitialValue = function (key) {
        var _a;
        var cookieKey = key === 'rego' ? 'vehicle_rego' : 'vehicle_state';
        return savedFormData[cookieKey] ||
            ((_a = formState.regoDetails) === null || _a === void 0 ? void 0 : _a[key]) ||
            (savedData === null || savedData === void 0 ? void 0 : savedData[key]) ||
            '';
    };
    // State management
    var _d = useState({
        rego: getInitialValue('rego'),
        state: getInitialValue('state')
    }), formValues = _d[0], setFormValues = _d[1];
    var _e = useState([]), states = _e[0], setStates = _e[1];
    var _f = useState(false), isLoadingStates = _f[0], setIsLoadingStates = _f[1];
    var _g = useState(false), isLoading = _g[0], setIsLoading = _g[1];
    var _h = useState(null), error = _h[0], setError = _h[1];
    var _j = useState(false), showExistingRegoDialog = _j[0], setShowExistingRegoDialog = _j[1];
    var _k = useState(null), existingSessionId = _k[0], setExistingSessionId = _k[1];
    var _l = useRegoLookup(), lookupVehicle = _l.lookupVehicle, lookupError = _l.error, errorAllowHtml = _l.errorAllowHtml;
    var _m = useState({
        lastName: '',
        phone: ''
    }), verificationData = _m[0], setVerificationData = _m[1];
    var _o = useState(null), verificationError = _o[0], setVerificationError = _o[1];
    var _p = useState(null), sessionError = _p[0], setSessionError = _p[1];
    var _q = useState(0), loadingProgress = _q[0], setLoadingProgress = _q[1];
    var autoSubmitRanRef = useRef(false);
    var isAutoSubmitRef = useRef(false);
    // --- Helper for fetching previous session (for verification dialog) ---
    var fetchAndRestoreSession = function (sessionId_1, lastName_1, phone_1) {
        var args_1 = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args_1[_i - 3] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([sessionId_1, lastName_1, phone_1], args_1, true), void 0, function (sessionId, lastName, phone, follow_up) {
            var result, sessionData, vehicleDetails, LAST_STEP, currentStep, nextStep, error_1;
            if (follow_up === void 0) { follow_up = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, ApiClient.fetchPreviousSession(sessionId, lastName, phone, follow_up)];
                    case 1:
                        result = _a.sent();
                        if (!result.success) {
                            throw new Error(result.error || 'Invalid or expired session link. Please start a new request.');
                        }
                        if (!result.data) {
                            throw new Error('Failed to fetch previous session data');
                        }
                        sessionData = Array.isArray(result.data) ? result.data[0] : result.data;
                        // Check if the session data itself indicates failure (verification failed)
                        if (sessionData && sessionData.success === false) {
                            throw new Error(sessionData.error || 'Verification failed');
                        }
                        // Update window.tiofSettings.savedData with the restored session data
                        if (window.tiofSettings) {
                            window.tiofSettings.savedData = sessionData;
                        }
                        // Set vehicle details in form context
                        if (sessionData.vehicle_details) {
                            vehicleDetails = void 0;
                            try {
                                vehicleDetails = typeof sessionData.vehicle_details === 'string'
                                    ? JSON.parse(sessionData.vehicle_details)
                                    : sessionData.vehicle_details;
                                dispatch(createSetVehicleDetailsAction(__assign({}, vehicleDetails)));
                            }
                            catch (err) {
                                console.error('Error parsing vehicle details:', err);
                            }
                        }
                        // Close dialog
                        setShowExistingRegoDialog(false);
                        LAST_STEP = 4;
                        currentStep = Number(sessionData.tiof_step) || 1;
                        nextStep = void 0;
                        if (currentStep === 3) {
                            nextStep = 3; // Don't increment if current step is 3
                        }
                        else if (currentStep >= LAST_STEP) {
                            nextStep = LAST_STEP;
                        }
                        else {
                            nextStep = currentStep + 1;
                        }
                        // Force a small delay to ensure cookie data is set
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                    case 2:
                        // Force a small delay to ensure cookie data is set
                        _a.sent();
                        dispatch(createSetStepAction(nextStep));
                        // Clear errors
                        setSessionError(null);
                        setVerificationError(null);
                        return [2 /*return*/, true];
                    case 3:
                        error_1 = _a.sent();
                        // Return error message for display
                        return [2 /*return*/, error_1 instanceof Error ? error_1.message : 'Something went wrong. Please try again later.'];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Auto-submit when coming from MiniRegoForm (tiof_auto=1) and values are present
    useEffect(function () {
        if (autoSubmitRanRef.current)
            return;
        var params = new URLSearchParams(window.location.search);
        var shouldAuto = params.get('tiof_auto') === '1';
        if (!shouldAuto)
            return;
        // Only proceed when we have rego, state, AND states array is loaded
        if (formValues.rego && formValues.state && states.length > 0 && !isLoadingStates) {
            autoSubmitRanRef.current = true;
            isAutoSubmitRef.current = true; // Mark as auto-submit to skip tracking
            // Clean the URL to avoid repeated auto-submits on navigation
            try {
                params.delete('tiof_auto');
                var newQuery = params.toString();
                var newUrl = "".concat(window.location.pathname).concat(newQuery ? "?".concat(newQuery) : '').concat(window.location.hash || '');
                window.history.replaceState({}, '', newUrl);
            }
            catch (_a) { }
            // Trigger the same submit flow with validation
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            var fakeEvent = { preventDefault: function () { } };
            void handleSubmit(fakeEvent);
        }
    }, [formValues.rego, formValues.state, states, isLoadingStates]);
    // Fetch states on component mount
    useEffect(function () {
        var isMounted = true;
        var fetchStates = function () { return __awaiter(void 0, void 0, void 0, function () {
            var statesData, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isMounted)
                            return [2 /*return*/];
                        setIsLoadingStates(true);
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ApiClient.fetchStates()];
                    case 2:
                        statesData = _a.sent();
                        if (isMounted) {
                            setStates(statesData);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        if (isMounted) {
                            setError(getTranslation('regoLookup.errors.statesFailed', 'Unable to load states. Please try again later.'));
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setIsLoadingStates(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchStates();
        return function () { isMounted = false; };
    }, []);
    // Simulate progress bar while loading
    useEffect(function () {
        if (!isLoading) {
            setLoadingProgress(0);
            return;
        }
        // Start at 0 and gradually increase
        setLoadingProgress(10);
        var interval = setInterval(function () {
            setLoadingProgress(function (prev) {
                // Slow down as it gets closer to 100
                if (prev < 30)
                    return prev + 10;
                if (prev < 60)
                    return prev + 5;
                if (prev < 90)
                    return prev + 2;
                if (prev < 95)
                    return prev + 1;
                return prev; // Stop at 95, will complete when API returns
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [isLoading]);
    // Handle form field changes
    var handleChange = function (e) {
        var _a = e.target, id = _a.id, value = _a.value;
        setFormValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[id] = value, _a)));
        });
    };
    // Handle verification input changes
    var handleVerificationChange = function (field) { return function (event) {
        setVerificationData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = event.target.value, _a)));
        });
        setVerificationError(null); // Clear any previous errors
    }; };
    // Form submission
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var recaptchaToken, siteKey_1, enabled, _a, existingCheck, existingData, selectedState, stateName, stateCode, result, err_1, msg, displayMsg;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    e.preventDefault();
                    // Input validation
                    if (!formValues.rego.trim()) {
                        setError(getTranslation('regoLookup.errors.emptyRego', 'Please enter a registration number'));
                        return [2 /*return*/];
                    }
                    if (!formValues.state) {
                        setError(getTranslation('regoLookup.errors.emptyState', 'Please select a state'));
                        return [2 /*return*/];
                    }
                    // Reset error state
                    setError(null);
                    setIsLoading(true);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 11, 12, 13]);
                    recaptchaToken = undefined;
                    siteKey_1 = (_c = (_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.recaptcha) === null || _c === void 0 ? void 0 : _c.siteKey;
                    enabled = (_e = (_d = window.tiofSettings) === null || _d === void 0 ? void 0 : _d.recaptcha) === null || _e === void 0 ? void 0 : _e.enabled;
                    if (!(enabled && siteKey_1 && window.grecaptcha)) return [3 /*break*/, 5];
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var grecaptcha = window.grecaptcha;
                            try {
                                grecaptcha.ready(function () {
                                    grecaptcha
                                        .execute(siteKey_1, { action: 'rego_lookup' })
                                        .then(function (token) { return resolve(token); })
                                        .catch(function () { return resolve(undefined); });
                                });
                            }
                            catch (_a) {
                                resolve(undefined);
                            }
                        })];
                case 3:
                    recaptchaToken = _f.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = _f.sent();
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, ApiClient.checkExistingRego(formValues.rego, formValues.state)];
                case 6:
                    existingCheck = _f.sent();
                    existingData = existingCheck.success &&
                        existingCheck.data &&
                        Array.isArray(existingCheck.data) &&
                        existingCheck.data.length > 0
                        ? existingCheck.data[0]
                        : null;
                    if (existingData &&
                        existingData.success &&
                        existingData.exists &&
                        existingData.session_id &&
                        existingData.session_id !== savedFormData.tiof_session_id) {
                        setExistingSessionId(existingData.session_id);
                        setShowExistingRegoDialog(true);
                        return [2 /*return*/]; // Add return to prevent proceeding to new request
                    }
                    selectedState = states.find(function (state) { return String(state.StateId) === String(formValues.state); });
                    stateName = selectedState ? selectedState.StateName : '';
                    stateCode = selectedState ? selectedState.StateCode : '';
                    // Save to context for new session
                    dispatch(createSetRegoDetailsAction({
                        rego: formValues.rego,
                        state: formValues.state,
                        stateName: stateName
                    }));
                    if (!USE_TEST_VEHICLES) return [3 /*break*/, 8];
                    // Simulate API delay
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                case 7:
                    // Simulate API delay
                    _f.sent();
                    // Track successful rego lookup (Step 0.5) - only for manual clicks, not auto-submit
                    if (!isAutoSubmitRef.current) {
                        trackFindYourCar();
                    }
                    onVehiclesFound(testVehicles);
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, lookupVehicle(formValues.rego, formValues.state, recaptchaToken, stateCode)];
                case 9:
                    result = _f.sent();
                    if (result && Array.isArray(result) && result.length > 0) {
                        // Track successful rego lookup (Step 0.5) - only for manual clicks, not auto-submit
                        if (!isAutoSubmitRef.current) {
                            trackFindYourCar();
                        }
                        onVehiclesFound(result);
                    }
                    else {
                        // No vehicles and no exception means treat as no-vehicles
                        setError(getTranslation('regoLookup.errors.noVehicles', 'No vehicles found for this registration. Please try again or select your vehicle manually.'));
                    }
                    _f.label = 10;
                case 10:
                    // Reset auto-submit flag for subsequent manual submissions
                    isAutoSubmitRef.current = false;
                    return [3 /*break*/, 13];
                case 11:
                    err_1 = _f.sent();
                    msg = err_1 instanceof Error ? err_1.message : '';
                    displayMsg = msg || getTranslation('regoLookup.errors.lookupFailed', 'Failed to lookup vehicle. Please try again or select your vehicle manually.');
                    if (msg && (msg.toLowerCase().includes('captcha verification failed') || msg.toLowerCase().includes('token missing'))) {
                        displayMsg += ' Please refresh the page and submit again.';
                    }
                    setError(displayMsg);
                    // Reset auto-submit flag even on error
                    isAutoSubmitRef.current = false;
                    return [3 /*break*/, 13];
                case 12:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 13: return [2 /*return*/];
            }
        });
    }); };
    // --- Handler for using previous session from dialog ---
    var handleUsePreviousSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errorMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!existingSessionId) {
                        setVerificationError('No existing session ID found');
                        return [2 /*return*/];
                    }
                    if (!verificationData.lastName.trim() || !verificationData.phone.trim()) {
                        setVerificationError('Please fill in both fields');
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    setError(null);
                    setVerificationError(null);
                    return [4 /*yield*/, fetchAndRestoreSession(existingSessionId, verificationData.lastName, verificationData.phone)];
                case 1:
                    errorMsg = _a.sent();
                    setIsLoading(false);
                    if (errorMsg !== true) {
                        setVerificationError(errorMsg);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // Add a handler to start a new request and clear the session error
    var handleStartNewRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!existingSessionId) return [3 /*break*/, 2];
                    return [4 /*yield*/, ApiClient.cancelSession(existingSessionId)];
                case 1:
                    result = _a.sent();
                    if (!result.success) {
                        setSessionError(result.error || 'Failed to cancel existing session');
                        return [2 /*return*/];
                    }
                    _a.label = 2;
                case 2:
                    setSessionError(null);
                    setShowExistingRegoDialog(false);
                    setExistingSessionId(null);
                    // Reset form state
                    setFormValues({ rego: '', state: '' });
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "rego-lookup", children: [_jsxs("form", { onSubmit: handleSubmit, children: [_jsx("div", { className: "form-group", children: _jsx("input", { type: "text", id: "rego", value: formValues.rego, onChange: handleChange, required: true, placeholder: getTranslation('regoLookup.inputRego', 'Enter Rego'), "aria-label": getTranslation('regoLookup.inputRego', 'Enter Rego') }) }), _jsx("div", { className: "form-group", children: _jsxs("select", { id: "state", value: formValues.state, onChange: handleChange, required: true, disabled: isLoadingStates, "aria-label": getTranslation('regoLookup.selectState', 'Rego State'), children: [_jsx("option", { value: "", children: getTranslation('regoLookup.selectState', 'Rego State') }), states && states.length > 0 ? (states.map(function (stateOption) { return (_jsx("option", { value: stateOption.StateId, children: stateOption.StateCode }, stateOption.StateId)); })) : (_jsx("option", { disabled: true, children: isLoadingStates ?
                                        getTranslation('loading', 'Loading states...') :
                                        getTranslation('regoLookup.noStates', 'No states available') }))] }) }), _jsx("div", { className: "form-group mb-center", children: _jsx("button", { type: "submit", disabled: isLoading || isLoadingStates, "aria-busy": isLoading, className: isLoading ? 'loading' : '', children: isLoading ? (_jsxs("span", { className: "button-loading", children: [_jsx("span", { className: "spinner" }), _jsxs("span", { className: "loading-texts", children: [getTranslation('loading', 'Loading'), _jsx("span", { className: "loading-dots" })] })] })) : (getTranslation('regoLookup.searchButton', 'Find Your Car')) }) }), USE_TEST_VEHICLES && (_jsx("div", { className: "test-mode-notice", role: "alert", children: _jsx("small", { children: "Test Mode Active: Using test vehicles data instead of API lookups" }) }))] }), error && (_jsx(SafeHtmlMessage, { message: error, allowHtml: errorAllowHtml, className: "error-message", role: "alert" })), sessionError && (_jsx("div", { className: "error-message", role: "alert", children: sessionError })), showExistingRegoDialog && (_jsx(Dialog, { isOpen: showExistingRegoDialog, onClose: function () { return setShowExistingRegoDialog(false); }, title: getTranslation('regoLookup.existingRego.title', 'Previous Registration Found'), children: _jsxs("div", { className: "existing-rego-dialog", children: [_jsx("p", { children: getTranslation('regoLookup.existingRego.message', 'We found a previous trade-in request for this registration number. Please verify your details to continue with the previous request.') }), _jsxs("div", { className: "verification-fields", children: [_jsx("div", { className: "form-group half-width", children: _jsx("input", { type: "text", id: "lastName", value: verificationData.lastName, onChange: handleVerificationChange('lastName'), placeholder: "Last Name", "aria-label": "Last Name" }) }), _jsx("div", { className: "form-group half-width", children: _jsx("input", { type: "tel", id: "phone", value: verificationData.phone, onChange: handleVerificationChange('phone'), placeholder: "Phone Number", "aria-label": "Phone Number" }) })] }), _jsxs("div", { className: "dialog-buttons", children: [_jsx("button", { onClick: handleUsePreviousSession, disabled: isLoading, className: "primary", children: isLoading ? 'Verifying...' : getTranslation('regoLookup.existingRego.usePrevious', 'Use Previous Details') }), _jsx("button", { onClick: handleStartNewRequest, disabled: isLoading, className: "secondary", children: getTranslation('regoLookup.existingRego.startNew', 'Start New Request') })] }), verificationError && (_jsx("div", { className: "error-message", role: "alert", children: verificationError }))] }) })), isLoading && (_jsx("div", { className: "loading-progress-bar-container", children: _jsx("div", { className: "loading-progress-bar", children: _jsx("div", { className: "progress-fill", style: { width: "".concat(loadingProgress, "%") } }) }) }))] }));
};
